<template>
  <div>
    <PageHeader page-name="Объявления">
      <template>
        <FilterPanel>
          <Filters @filter="doFilter" />
        </FilterPanel>
      </template>
    </PageHeader>
    <MainPanel>
      <List v-loading="loading" @sort="doSort" />

      <el-pagination
        v-if="meta"
        background
        :current-page="filterObject.page"
        hide-on-single-page
        layout="prev, pager, next"
        :page-size="meta.per_page"
        :total="meta.total"
        @current-change="changePage"
      />
    </MainPanel>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import List from '@/components/products/List.vue'
import MainPanel from '@/components/common/MainPanel'
import FilterPanel from '@/components/common/FilterPanel'
import PageHeader from '@/components/common/PageHeader';
import Filters from '@/components/products/Filters';


export default {
  components: {Filters,  MainPanel, List, PageHeader, FilterPanel},
  metaInfo: {
    title: 'Обьявление',
  },
  data() {
    return {
      loading: false,
      filterObject: {
        page: 1,
      },
    }
  },
  computed: {
    ...mapState('products', [
      'products',
    ]),
    meta() {
      return this.products?.meta
    },
  },
  methods: {
    ...mapActions('products', [
      'fetchProducts',
    ]),
    async getProducts() {
      this.loading = true
      await this.fetchProducts(this.filterObject)
      this.loading = false
    },
    changePage(page) {
      this.filterObject.page = page
      this.getProducts()
    },
    doFilter(filters) {
      this.filterObject = {...this.filterObject, ...filters}
      this.filterObject.page = 1
      this.getProducts()
    },
    doSort(sort) {
      this.filterObject = {...this.filterObject, ...sort}
      this.filterObject.page = 1
      this.getProducts()
    },
  },
}
</script>
